/*
 *  (c) 2015 - 2022 ENISCO by FORCAM GmbH
 */

import {DialogContent} from '@mui/material'
import React from 'react'
import TabPanel from '../menu/tabs/TabPanel'
import {DialogEntry} from './MyProfileDialog'

interface MyProfileTabSetProps {
  tabValue: number
  entries: DialogEntry[]
}

const MyProfileDialogContentSet: React.FC<MyProfileTabSetProps> = ({
  tabValue,
  entries
}) => {
  return (
    <DialogContent sx={{padding: 0}}>
      {entries.map((entry, index) => (
        <TabPanel
          value={tabValue}
          index={index}
          key={entry.key}
          data-testid={`MyProfileDialogContentSet:${entry.key}`}
        >
          {entry.createComponent()}
        </TabPanel>
      ))}
    </DialogContent>
  )
}

export default MyProfileDialogContentSet
